// extracted by mini-css-extract-plugin
export default {"addToCartControl":"BY-z","giftCard":"CY-z","btnContainer":"DY-z","cartButton":"EY-z","disabled":"FY-z"};